import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Phone = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M6.68 4.038A3.62 3.62 0 0 1 10.297.42h23.244a3.608 3.608 0 0 1 3.604 3.618v36.764a3.62 3.62 0 0 1-3.618 3.618h-23.23a3.62 3.62 0 0 1-3.617-3.618V4.038Zm3.617-1.523c-.835 0-1.522.68-1.522 1.523v36.764c0 .836.68 1.523 1.522 1.523h23.23c.836 0 1.522-.68 1.522-1.523V4.038c0-.85-.68-1.523-1.508-1.523H10.298Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M11.094 8.857c0-.579.469-1.048 1.047-1.048h19.556a1.048 1.048 0 1 1 0 2.095H12.14a1.048 1.048 0 0 1-1.047-1.047ZM11.094 33.664c0-.578.469-1.047 1.047-1.047h19.556a1.048 1.048 0 0 1 0 2.095H12.14a1.048 1.048 0 0 1-1.047-1.048ZM20.145 38.372c0-.579.47-1.048 1.048-1.048h1.452a1.048 1.048 0 0 1 0 2.095h-1.452a1.048 1.048 0 0 1-1.048-1.047Z"
  })));
});
Phone.displayName = 'Phone';
Phone.defaultProps = {
  'aria-label': 'Phone'
};
export default Phone;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Phone.js
// module id = 3870
// module chunks = 11